var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: 'profile' }}},[_c('i',{staticClass:"fas fa-4x fa-user-circle align-middle mr-2",staticStyle:{"color":"#fff"}}),_c('span',{staticClass:"username ml-2 align-middle"},[_vm._v(_vm._s(_vm.currentUser.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }